import React from 'react';
import PropTypes from "prop-types";
import { ContainerCard, FlowCardGrid, DarkerDivider } from './styles';
let firstRowGrids = true;
const borderBottomNoneQ = [];

export function trackGrids(grid) {
  let cardRowWidth = 0;
  cardRowWidth += +grid.gridWidth;
  const ceilWidth = Math.ceil(cardRowWidth);
  if (firstRowGrids) {
    if (ceilWidth === 100) {
      cardRowWidth = 0;
      firstRowGrids = false;
    }
    return true;
  }
  if (borderBottomNoneQ.length && ceilWidth < 100) {
    return true;
  }
  if (ceilWidth === 100 && borderBottomNoneQ.length) {
    while (borderBottomNoneQ.length) {
      borderBottomNoneQ.shift();
    }
    cardRowWidth = 0;
    return true;
  }
  if (ceilWidth === 100) cardRowWidth = 0;
  return false;
}

export function gridStyle(width) {
  return {
    width: `${width}%`,
  };
}

function FlowCard(props) {
  const { cardConfig, styleConfig, index, stickyId } = props;

  if (!cardConfig) return <div data-test="no-data">no data</div>;
  return (
    <ContainerCard
      data-test = "wrapper"
      bordered={styleConfig && styleConfig.cardBorder}
      cardParity={index}
      cardPadding={styleConfig && styleConfig.cardPadding}
      styleConfig={styleConfig}
    >
      {cardConfig.map((each, gridIndex) => {
        if (each.noBorderBottom) {
          borderBottomNoneQ.push(each.name);
        }
        return (
          <FlowCardGrid
            id={stickyId || ''}
            cardDetail={{
              type: each.type,
              gridWidth: each.gridWidth,
              ptop: each.ptop,
              pbottom: each.pbottom,
              pleft: each.pleft,
              pright: each.pright,
            }}
            gridIndex={gridIndex}
            style={gridStyle(each.gridWidth)}
            borderNone={(gridIndex === 1 || gridIndex === 2) ? true : false }
          >
            {each.render}
          </FlowCardGrid>
        );
      })}
      <DarkerDivider
        className={
          props.dataIndex !== props.length - 1
            && (props.styleConfig && props.styleConfig.cardDivider === false)
            ? 'mt1 mb1'
            : 'display-none'
        }
      />
    </ContainerCard>
  );
}

FlowCard.propTypes = {
  dataIndex: PropTypes.number,
  styleConfig: PropTypes.object
}

export default FlowCard;
